<template>
  <div style="height: 100%">
    <div class="sa-flexbox" style="padding-bottom: 20px">
      <div class="sa-flexbox-body">
        <div class="d-flex flex-column">
          <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
            <b-col lg="3">
              <p>Records Totali: {{ rows }}</p>
            </b-col>
            <b-col lg="9">
              <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right"
                size="sm"></b-pagination>
            </b-col>
          </b-row>
        </div>
        <div class="b-table-sticky-header" style="margin-bottom: 1px;">
          <transition name="animation" mode="out-in">
            <div v-if="items && items.length > 0" key="cards" style="padding: 2px">
              <div class="sa-ft-card-list" v-show="initComponent">
                <div v-for="(item, index) in items" :key="item.primaryKey || index" class="sa-ft-modern-card"
                  :style="{ '--hover-color': getClass('hover', 'ACCETTATO') }" :class="getClass('card', 'ACCETTATO')">
                  <div class="sa-ft-modern-clinical">
                    <section class="sa-ft-section-container">
                      <div class="sa-ft-form-card">
                        <div class="sa-ft-card-header">
                          <div class="sa-ft-section-icon">👤</div>
                          <h3>{{ item.patient.name }}
                            <h3 class="cursive">{{ item.patient.code }}</h3>
                          </h3>
                          <div style="display: table; margin-left: auto; text-align: right;">
                            <label class="sa-ft-label">NRE</label>
                            <h3> {{ item.prescription.nre }}</h3>
                          </div>
                        </div>
                        <div class="sa-ft-grid">
                          <div class="sa-ft-field flex-1">
                            <div class="sa-ft-icon-box">✍🏻</div>
                            <div class="sa-ft-inner-row">
                              <div class="sa-ft-inner-column flex-main">
                                <label class="sa-ft-form-label">Prescrizione</label>
                                <span class="sa-ft-value">{{ item.patient.name }}</span>
                              </div>
                              <!-- <button v-if="!jsonData.id || jsonData.id == '-1'" type="button"
                                @click="onRicercaAssistito" class="sa-ft-action-btn primary">
                                <span>Verifica</span>
                                <small>🔍</small>
                              </button> -->

                            </div>
                          </div>
                          <div class="sa-ft-field flex-1">
                            <div class="sa-ft-icon-box">👤</div>
                            <div class="sa-ft-data">
                              <label class="sa-ft-label">Nominativo</label>
                              <span class="sa-ft-value">{{ item.patient.name }}</span>
                            </div>
                          </div>
                          <div class="sa-ft-field flex-1">
                            <div class="sa-ft-icon-box">👤</div>
                            <div class="sa-ft-data">
                              <label class="sa-ft-label">Data Ingresso</label>
                              <span class="sa-ft-value"> {{ formatIso(item.prescription.entryDatetime) }}</span>
                            </div>
                          </div>

                        </div>
                        <div class="sa-ft-card-header">
                          <div class="sa-ft-section-icon">✍🏻</div>
                          <h3>Prescrizione</h3>

                          <div style="display: table; margin-left: auto; text-align: right;">
                            <label class="sa-ft-label">Priorità</label>
                            <h3> {{ item.prescription.priorityClass.id }}</h3>
                          </div>
                        </div>
                        <div class="sa-ft-grid">
                          <div class="sa-ft-field flex-1">
                            <div class="sa-ft-icon-box">📅</div>
                            <div class="sa-ft-data">
                              <label class="sa-ft-label">Data Prescrizione</label>
                              <span class="sa-ft-value">{{ formatIso(item.prescription.compilationDatetime) }}</span>
                            </div>
                          </div>
                          <div class="sa-ft-field flex-1">
                            <div class="sa-ft-icon-box">🚻</div>
                            <div class="sa-ft-data">
                              <label class="sa-ft-label">Tipo</label>
                              <span class="sa-ft-value"> {{ item.prescription.prescriptionType.name }}</span>
                            </div>
                          </div>
                          <div class="sa-ft-field flex-1">
                            <div class="sa-ft-icon-box">🚻</div>
                            <div class="sa-ft-data">
                              <label class="sa-ft-label">Esenzione</label>
                              <span class="sa-ft-value"> {{ item.prescription.exemption.name }}</span>
                            </div>
                          </div>
                        </div>
                        <div class="sa-ft-card-header">
                          <div class="sa-ft-section-icon">🚀</div>
                          <h3>Prestazioni</h3>
                          <div style="display: table; margin-left: auto; text-align: right;">
                            <span class="sa-ft-circle-wrapper"> {{ item.details.length }}</span>

                          </div>
                        </div>
                        <div class="sa-ft-card-details-bar" v-if="item.details && item.details.length > 0">
                          <ul v-for="(prestazione, index) of item.details" :key="index">

                            <li>
                              <b-row align-v="center" class="m-0 py-3">
                                <b-col cols="12" md="4" class="mb-2 mb-md-0">
                                  <div class="sa-ft-label">
                                    Prestazione:
                                  </div>
                                  <div class="sa-ft-value"> {{ prestazione.service.name }}</div>
                                  <div class="sa-ft-value-sub cursive"> {{ prestazione.service.code }}</div>
                                  <div class="sa-ft-value ml-1">
                                    <!-- {{ getNominativoAssistito(item, "identificativo") }} -->
                                  </div>
                                </b-col>
                                <b-col cols="12" md="2" class="mb-2 mb-md-0">
                                  <div class="sa-ft-label">
                                    Quantita/Accessi
                                  </div>
                                  <div class="sa-ft-value">
                                    <span class="sa-ft-badge info">{{ prestazione.quantity }}</span>
                                  </div>
                                  <div class="sa-ft-value-sub"> {{ prestazione.service.groupId }}</div>
                                </b-col>
                                <b-col cols="12" md="2" class="mb-2 mb-md-0">
                                  <div class="sa-ft-label">
                                    Stato
                                  </div>
                                  <div class="sa-ft-value">
                                    <span class="sa-ft-badge info">{{ prestazione.status.name }}</span>
                                  </div>
                                  <div v-if="prestazione.statusReason" class="sa-ft-value-sub">
                                    {{
                                      prestazione.statusReason.name }}
                                  </div>

                                </b-col>
                                <b-col cols="12" md="3" class="mb-2 mb-md-0">
                                  <div class="sa-ft-value-combine-wrapper">
                                    <span class="sa-ft-label">APPUNTAMENTO PREV.</span>
                                    <div class="sa-ft-value-combine">
                                      <div class="sa-ft-value-combine-row">
                                        <span class="sa-ft-value-combine-label">Inizio:</span>
                                        <span class="sa-ft-value-combine-value">
                                          {{ formatDateIso(prestazione.executionDatetime) }}
                                          {{ formatTime(prestazione.booking.startTime)
                                          }}</span>
                                      </div>
                                      <div class="sa-ft-value-combine-row">
                                        <span class="sa-ft-value-combine-label">Fine:</span>
                                        <span class="sa-ft-value-combine-value">
                                          {{ formatDateIso(prestazione.executionDatetime) }}
                                          {{
                                            formatTime(prestazione.booking.endTime)
                                          }}</span>
                                      </div>
                                    </div>
                                  </div>
                                </b-col>
                              </b-row>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </section>
                  </div>
                </div>
              </div>
            </div>
            <NoDataComponent v-else ref="cmpNoDataComponent"
              title="Non sono presenti prenotazioni per la data riferimento" nome="no-data" subtitle=""
              icon="fas fa-users" />
          </transition>
        </div>
      </div>
      <div class="d-flex flex-column">
        <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
          <b-col lg="3">
            <p>Records Totali: {{ rows }}</p>
          </b-col>
          <b-col lg="9">
            <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right"
              size="sm"></b-pagination>
          </b-col>
        </b-row>
      </div>
      <b-modal ref="mdlScelta">
        <template></template>
      </b-modal>

      <pdf-print-view-embedded ref="pdfPrintViewEmbedded" :pdf="signedPdfViewer"></pdf-print-view-embedded>
    </div>
  </div>
</template>

<script>
// import PrintComponent from "../../../utility/components/PdfPrintViewEmbedded.vue";
import UtilityMixin from "../../../utility/UtilityMixin";
import PdfPrintViewEmbedded from "../../../utility/components/PdfPrintViewEmbedded.vue";
//import PrintComponent from "../../../utility/components/PrintComponent.vue";
import NoDataComponent from "../../../../template/components/utility/NoDataComponent.vue";
import moment from "moment";
import toast from "../../../../template/layout/utility/sa-toast";
// import toast from "../../../../template/layout/utility/sa-toast";
export default {
  //PrintComponent
  mixins: [UtilityMixin],
  components: { PdfPrintViewEmbedded, NoDataComponent },
  data() {
    return {
      initComponent: false,
      pathResource: "/saccsarr/appuntamenti/base",
      items: [],
      rows: 0,
      filtro: {
        cfPaziente: null,
        startTime: new Date().getTime(),
        endTime: new Date().getTime(),
      },
      page: 1,
      perPage: 20,
      signedPdfViewer: null,
      previewSelected: null,
      currentPage: 1,
      rowSelectedAccettazione: {},
      listaRicetteDetails: {},

    };
  },

  mounted() {

    //me.init();

  },
  methods: {
    init() {
      let me = this;
      me.loadData();
    },
    getClass(sezione, valore) {

      switch (sezione) {
        case 'stato':
          if (valore == 'ACCETTATO') {
            return 'sa-ft-modern-card-default'
          } else if (valore == 'IN CORSO') {
            return 'sa-ft-modern-card-blue'
          } else if (valore == 'IN ATTESA') {
            return 'sa-ft-modern-card-green'
          }
          else {
            return 'sa-ft-modern-card-red'
          }
        case 'gruppo':
          if (valore == 'ACCETTATO') {
            return 'sa-ft-modern-card-default'
          } else if (valore == 'IN CORSO') {
            return 'sa-ft-modern-card-blue'
          } else if (valore == 'IN ATTESA') {
            return 'sa-ft-modern-card-green'
          }
          else {
            return 'sa-ft-modern-card-red'
          }
        case 'card':
          if (valore == 'ACCETTATO') {
            return 'sa-ft-modern-card-default'
          } else if (valore == 'IN CORSO') {
            return 'sa-ft-modern-card-blue'
          } else if (valore == 'IN ATTESA') {
            return 'sa-ft-modern-card-green'
          }
          else {
            return 'sa-ft-modern-card-red'
          }
        default:
          break;
      }
    },

    getOra(date) {
      return moment(date).format("HH:mm");
    },
    getFormatDate(date) {
      return moment(date).format("DD/mm/yyyy");
    },
    onClickSchedaPaziente(item) {
      this.$router.push("/accettazionessn/schedapaziente/" + item.id)
    },


    loadData() {
      let me = this;
      me.$emit("beforeLoadData");
      me.items = [];
      let filtroStr = sessionStorage.getItem("filtroPagePrenotazioniLazio");
      let filtroJson = JSON.parse(filtroStr);
      me.filtro = filtroJson;
      this.$emit("updateFilter", me.filtro)
      this.initComponent = true;
      if (this.filtro.cfPaziente != null && !this.filtro.cfPaziente.isBlank()) {
        console.log("CARICO PRIMA ID DEL PAZIENTE E POI FACCIO CHIAMATA !");
      }
      this.loadDataResources(me.pathResource, me.filtro, me.loadDataAccettazioneSsnSuccess, me.loadDataAccettazioneSsnError);
    },

    loadDataAccettazioneSsnSuccess(response) {
      let me = this;
      if (response.data.data) {

        me.items = response.data.data.content;
        me.rows = response.data.data.content.length;
        toast.success("Prenotazioni Cariche con successo")
      } else {
        toast.warning("Non ci sono prenotazioni per la data corrente")
      }
      me.$emit("afterLoadData");
    },
    loadDataAccettazioneSsnError(error) {
      error;
    },

  },
  watch: {
    currentPage() {
      let me = this;
      me.loadData();
    },
  },
};
</script>

<style scoped>
.animation-enter-active,
.animation-leave-active {
  transition: opacity 0.8s ease, transform 0.8s ease;
}

.animation-enter-from {
  opacity: 0;
  transform: translateY(20px);
}

.animation-enter-to {
  opacity: 1;
  transform: translateY(0px);
}

.animation-leave-from {
  opacity: 1;
  transform: translateY(0px);
}

.animation-leave-to {
  opacity: 0;
  transform: translateY(20px);
}

.sa-ft-value-combine-wrapper {
  font-family: 'Segoe UI', Roboto, sans-serif;
  padding: 10px;
  border-radius: 8px;
  max-width: 200px;
}

.sa-ft-value-combine {
  margin-top: 8px;
  padding-left: 5px;
}

.sa-ft-value-combine-row {
  display: flex;
  justify-content: flex-start;
  gap: 10px;
  margin-bottom: 4px;
}

.sa-ft-circle-wrapper {
  /* Dimensioni e Forma */
  width: 30px;
  aspect-ratio: 1 / 1;
  border-radius: 50%;

  /* Centratura del numero */
  display: flex;
  align-items: center;
  justify-content: center;

  /* Estetica */
  background-color: #007bff21;
  color: rgba(0, 47, 255, 0.712);
  font-family: sans-serif;
  font-weight: bold;
  font-size: 1.2rem;

  /* Opzionale: bordino o ombra */
  border: 2px solid #0056b3;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.sa-ft-value-combine-label {
  font-size: 0.85rem;
  color: #6c757d;
  font-weight: 600;
  width: 40px;
}

.sa-ft-value-combine-value {
  font-size: 0.9rem;
  color: #212529;
  font-weight: 700;
}
</style>
